import { Box, Button, CircularProgress, Modal, Stack, Typography, keyframes } from "@mui/material"
import { RobotDetailData } from "../types/Robot"
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { getRobotDoorStatus, getSimulateRobotTouchScreen, postCloseRobotDoors, postOpenDoor } from "../api/robot";
import { PinCode } from "./PinCode";
import { TaskRecordCollectionData } from "../types/TaskCollection";

const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const NotificationPinCode = (props: {
    robot: RobotDetailData | undefined,
    handleLoadedItem: () => void,
    message: string,
    subtitle: string,
    displayImg: string,
    completedText: string,
}) => {
    const {robot, handleLoadedItem, message, subtitle, displayImg, completedText} = props
    const [playAudio, setPlayAudio] = useState<boolean>(true);
    const [authorized, setAuthorized] = useState<boolean>(false);
    const [waitAcknowledgement, setWaitAcknowledgement] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [showPinPage, setShowPinPage] = useState<boolean>(false);
    const [isPlaying, setIsPlaying] = useState<boolean>(false)

    const block = (delay: number) => {
        const now = (new Date()).getTime()
        
        while (((new Date()).getTime() - now) <= delay) {
          // do nothing
        }
      }

    useQuery("audioOnce", async () => {
        if (!authorized && !isPlaying) {
            setIsPlaying(true)
            const audio = new Audio("./assets/sound/robot_is_here.mp3")
            await audio.play();
            setIsPlaying(false)
        }
    },
    {
        refetchInterval: 20000
    })

    const handleCloseDoors = async () => {
        setLoading(true)
        await postCloseRobotDoors(1);
        setAuthorized(false)
        setLoading(false)
        handleLoadedItem()
    }

    const handleOpenDoors = async () => {
        setLoading(true)
        setShowPinPage(false)
        setAuthorized(true)
        setLoading(false)
    }

    return <>
    {<><Box sx={{
        width: "52%",
        height: true ? "85%" : "83%",
        backgroundColor: "#F53649",
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "32px",
        animation: `${blink} 0.3s linear infinite`,
        animationDirection: 'alternate',}}/>
    <Stack sx={{
        width: "48%",
        height: true ? "80%" : "76%",
        backgroundColor: "#FFFFF9",
        justifyContent: "center",
        alignItems: "center",
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "24px",
    }}>
        {showPinPage ? 
            <PinCode doorIndex={0} successHandler={handleOpenDoors} />
            : <>
            {robot ? <img src={robot.image} alt={robot.name}/> : <></>}
            <Typography sx={{
                fontSize: "36px",
                paddingTop: true ? "0px" : "24px",
                color: "#000000",
                fontWeight: "bold"
            }}>{message}</Typography>
            <Typography sx={{
                fontSize: "24px",
                paddingTop: true ? "0px" : "16px",
                paddingBottom: false ? "6px" : "16px",
                color: "#B9B9B9",
            }}>{subtitle}</Typography>
            {false &&  <Button sx={{
                backgroundColor: "#1976d2",
                color: "#F9F9F9",
                borderRadius: "45px",
                fontSize: "24px",
                paddingLeft: "36px",
                paddingRight: "36px",
                paddingTop: "8px",
                paddingBottom: "8px",
                ":hover": {
                    backgroundColor: "#1565c0",
                },
                textTransform: "none",
            }} onClick={handleCloseDoors}>Dismiss</Button>}
            {
                loading ?
                <CircularProgress /> :
                !authorized ? 
                <Button sx={{
                    backgroundColor: "#1976d2",
                    color: "#F9F9F9",
                    borderRadius: "45px",
                    fontSize: "24px",
                    paddingLeft: "36px",
                    paddingRight: "36px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    ":hover": {
                        backgroundColor: "#1565c0",
                    },
                    textTransform: "none",
                }} onClick={() => {setShowPinPage(true)}}>Open Door</Button> :
                <Button variant="contained" 
                color="success" onClick={handleCloseDoors} sx={{
                    borderRadius: "45px",
                    fontSize: "24px",
                    paddingLeft: "36px",
                    paddingRight: "36px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    textTransform: "none",
                }}>{completedText}</Button>
            }
        </>}
        
    </Stack>
    </>}
    </>;
}